import { Inject, Injectable, InjectionToken } from '@angular/core';
import { environment } from '@env/environment';


export enum LogLevel{
  None = 0,
  Info ,
  Verbose ,
  Warn ,
  Error 
}

export const LogLevelToken= new InjectionToken<LogLevel>('LogLevel')

@Injectable({
  providedIn:"root"
})
export class LoggerService {
  private logs: string[] = [];
  constructor(@Inject(LogLevelToken) private logLevel:LogLevel) { }

  //  /**
  //  * Logs a message with timestamp
  //  * @param message The message to log
  //  * @param level The log level (default: 'INFO')
  //  */
   log(message: string, level: 'INFO' | 'WARN' | 'ERROR' = 'INFO'): void {
    const timestamp = new Date().toISOString();
    const logEntry = `[${timestamp}] ${level}: ${message}`;
    this.logs.push(logEntry);
   
    if (environment.enableLogging) {
      // Development: Log to console
      const formattedLog = `[${timestamp}] ${level}: ${message}`;
      console.log(formattedLog);
    }
    // Production: Logs are stored in this.logs for JSON export


    
  }
  /**
   * Logs a warning message
   * @param message The warning message to log
   */
  warn(message: string): void {
    this.log(message, 'WARN');
  }

  /**
   * Logs an error message
   * @param message The error message to log
   */
  error(message: string): void {
    this.log(message, 'ERROR');
  }

  /**
   * Retrieves all logged messages
   * @returns Array of log entries
   */
  getLogs(): string[] {
    return [...this.logs];
  }

  /**
   * Clears all logged messages
   */
  clearLogs(): void {
    this.logs = [];
  }

  
  /**
   * Generates and downloads logs as a JSON file (for production)
   */
  downloadLogsAsJson(): void {
    if (!environment.production) {
      console.warn('Log download is only available in production');
      return;
    }

    const logsJson = JSON.stringify(this.logs, null, 2);
    const blob = new Blob([logsJson], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `logs-${new Date().toISOString()}.json`;
    a.click();
    window.URL.revokeObjectURL(url);
  }
}
